
import { httpservice } from '../services';
import { constants } from '../constant/constant';
import {ENTITY} from '../constant';
import {httpserviceWithMultipart} from "../services/HttpServices";
let apiEndPoint = constants.ADMIN_URL;

export const doGalleryCreate = data => {
    return httpserviceWithMultipart('post', data, `${apiEndPoint}${constants.API.GALLERY}`)
        .then( (response) => {
            console.log(response)

            return {status:1,data:response.data};
        })
        .catch(function (error) {
            return {status:0,data:error.response && error.response.data ? error.response.data : error};
        });

};

export const doGalleryDelete = Id => {
    const endPointUri = constants.API.GALLERY_BY_ID.replace(ENTITY.GALLERY_ID, Id);
    return httpservice()
        .delete(endPointUri)
        .then(function (response) {
            return {status:1,data:response.data};
        })
        .catch(function (error) {
            return {status:0,data:error.response && error.response.data ? error.response.data : error};
        });
};

export const doGalleryUpdate = (Id, data) => {
    const endPointUri = constants.API.GALLERY_BY_ID.replace(ENTITY.GALLERY_ID, Id);
    
    return httpserviceWithMultipart('put', data, `${apiEndPoint}${endPointUri}` )
        .then(function (response) {
            return {status:1,data:response.data};
        })
        .catch(function (error) {
            return {status:0,data:error.response && error.response.data ? error.response.data : error};
        });
};
